import { getReportsIncludedInReportSet, cachedGetUniqueQueryParams } from '../../../shared/customReports/helpers';
import { CustomReportTypes } from '../../../shared/customReports/constants';

export default (customReportSetToEdit = null, customReports = []) => {
  const reports = customReportSetToEdit && customReportSetToEdit.reports
    ? customReportSetToEdit.reports
    : [];

  const fields = ({
    name: {
      value: customReportSetToEdit && customReportSetToEdit.reportSetName
        ? customReportSetToEdit.reportSetName
        : '',
      isValid: !!customReportSetToEdit,
    },
    reports: {
      value: reports,
      isValid: !!customReportSetToEdit,
    },
    id: {
      value: customReportSetToEdit && customReportSetToEdit.reportSetId
        ? customReportSetToEdit.reportSetId
        : null,
      isValid: true,
    },
    display: {
      value: customReportSetToEdit && customReportSetToEdit.customReportFlag
        ? customReportSetToEdit.customReportFlag
        : false,
      isValid: true,
    },
    customReportType: {
      value: CustomReportTypes.REPORT_SET,
      isValid: true,
    },
  });

  const reportsIncludedInReportSet = getReportsIncludedInReportSet(customReports, reports);
  const { queryParams, paramToUniqueIdMapping, uniqueParams } = cachedGetUniqueQueryParams(reportsIncludedInReportSet);


  return {
    formData: {
      ...fields,
    },
    queryParams,
    mapping: paramToUniqueIdMapping,
    uniqueParams,
    reportsIncludedInReportSet,
    isFormValid: !!customReportSetToEdit,
    triedToSubmitForm: false,
    elementsToValidate: [],
    shouldResetValues: false,
  };
};
